import React from 'react';

const DownloadReportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.625 17.4203H15.8731C16.2182 17.4203 16.4981 17.7002 16.4981 18.0453C16.4981 18.3618 16.2629 18.6233 15.9578 18.6646L15.8731 18.6703H4.625C4.27983 18.6703 4 18.3905 4 18.0453C4 17.7289 4.23513 17.4674 4.54019 17.426L4.625 17.4203H15.8731H4.625ZM10.1528 2.00561L10.25 2C10.6773 2 11.0296 2.3217 11.0778 2.73615L11.0833 2.83333V13.325L13.8284 10.581C14.1288 10.2807 14.6015 10.2576 14.9284 10.5118L15.0069 10.5812C15.3072 10.8816 15.3303 11.3543 15.0761 11.6812L15.0067 11.7597L10.8421 15.9235C10.5418 16.2237 10.0694 16.2469 9.7425 15.9931L9.664 15.9238L5.49448 11.76C5.16882 11.4348 5.16846 10.9072 5.49367 10.5815C5.79387 10.2808 6.26655 10.2574 6.59363 10.5114L6.67218 10.5807L9.41667 13.3208V2.83333C9.41667 2.40597 9.73833 2.05375 10.1528 2.00561L10.25 2L10.1528 2.00561Z"
      fill="#27B0E0"
    />
  </svg>
);

export default DownloadReportIcon;
